"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
require("typeface-lato");
// A custom theme for this app
var theme = (0, styles_1.createMuiTheme)({
    typography: {
        // useNextVariants: true,
        fontFamily: "Lato"
    },
    overrides: {
        MuiDrawer: {
            paper: {
                background: "#004b2c",
                "& *": { color: "#fff" }
            }
        },
        MuiExpansionPanel: {
            root: {
                backgroundColor: "#fafafa"
            }
        },
        MuiListItemText: {
            root: {
                "& *": { color: "#fff" }
            }
        },
        MuiTableCell: {
            head: {
                fontWeight: 700,
                fontSize: "small",
                color: "#000"
            }
        },
        MuiListItemIcon: {
            root: {
                minWidth: "30px"
            }
        }
    },
    palette: {
        primary: {
            main: "#014630",
            contrastText: "#ffffff"
        },
        secondary: {
            main: "#f88a27",
            contrastText: "#ffffff"
        }
    }
});
exports.default = theme;
//# sourceMappingURL=Agro.js.map